import React, { useEffect, useRef, useState } from 'react';

import { ArrowLeftOutlined } from '@ant-design/icons';
// import { get } from 'lodash';
import { NavLink, useLocation } from 'react-router-dom';

import styles from '../searchReport/style.module.scss';

const WhoWeAre: React.FC<Props> = ({ history }) => {
  const vidRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  window.scrollTo(0, 0);
  const location = useLocation();
  const subTab = location.state?.name?.properties?.name;
  useEffect(() => {
    if (vidRef.current) {
      vidRef.current
        .play()
        .catch((error) => console.error('Autoplay failed:', error));
    }

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
      <div
        style={{ marginTop: 100, marginLeft: 50 }}
        className={styles.vGoBackSaveBar}
      >
        <p
          style={{ zIndex: '10' }}
          onClick={() => (history ? history.goBack() : history.push('/'))}
          className={styles.vGoBackBtnBlock}
        >
          <span className={styles.vGoBackBtn}>
            <ArrowLeftOutlined /> Go Back
          </span>
        </p>
      </div>
      <div
        style={{
          minHeight: '500px',
          marginTop:
            subTab === 'Overview' || subTab === 'Success Stories'
              ? '-100px'
              : '',
        }}
      >
        <p
          className={styles.Heading}
          style={{
            top: '-40px',
            display: 'flex',
            justifyContent: 'center',
            color: '#1abd50',
            // marginTop: '100px',
            fontFamily: `'Jost', sans-serif`,
            fontSize: '2rem',
            lineHeight: '1.1',
            fontWeight: 'bold',
          }}
        >
          {subTab === 'Our Features'
            ? 'What We Offer'
            : subTab === 'Overview' || subTab === 'Success Stories'
            ? ''
            : subTab}
        </p>
        {subTab === 'Overview' ? (
          <div
            style={{
              color: '#FFFFFF',
              textAlign: 'center',
              padding: 40,
            }}
          >
            {/* Top Section with Text and Image */}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: 1200,
                margin: 'auto',
                gap: 30,
              }}
            >
              {/* Left Text Content */}
              <div style={{ flex: 1, minWidth: 350, textAlign: 'left' }}>
                <h2
                  style={{
                    fontSize: 32,
                    fontWeight: 'bold',
                    color: 'white',
                    marginBottom: 20,
                  }}
                >
                  What is <span style={{ color: '#00FF99' }}>ThinkSabio?</span>
                </h2>

                <p
                  style={{
                    color: '#D3D3D3',
                    fontSize: 18,
                    lineHeight: 1.5,
                  }}
                >
                  ThinkSabio is an AI-based stock analytical tool developed
                  using Data Science, AI & ML. We provide intelligent insights
                  for the stock market, giving access to thousands of stocks,
                  institutional investors, and insiders.
                </p>
                <NavLink to="/free-trial">
                  <button
                    style={{
                      backgroundColor: '#1abd50',
                      color: 'white',
                      fontWeight: 'bold',
                      padding: isMobile ? '1rem' : '0.75rem 1.5rem',
                      marginTop: '30px',
                      width: isMobile ? '100%' : 'auto',
                      border: 'none',
                      borderRadius: '0.5rem',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = 'transparent')
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = '#1abd50')
                    }
                  >
                    Get Started
                  </button>
                </NavLink>
              </div>

              {/* Stock Analysis Image (Top-Right) */}
              <div
                style={{
                  flex: 1,
                  minWidth: 350,
                  textAlign: 'center',
                  transform: 'scale(0.9)',
                }}
              >
                <img
                  src="https://thinksabio-asset.s3.us-east-1.amazonaws.com/LandingPageReportSummary.png"
                  alt="How it works"
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '8px',
                  }}
                />
              </div>
            </div>

            {/* Feature Cards */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: 20,
                maxWidth: 1200,
                margin: '20px auto 0',
              }}
            >
              {[
                {
                  title: 'Institutional-Grade Intelligence',
                  description:
                    'Our information comes directly from institutional investors with expertise in economics, data analysis, and mathematics.',
                  borderColor: '#00FF99',
                },
                {
                  title: 'Higher Returns',
                  description:
                    'ThinkSabio helps subscribers make informed stock market decisions through simplified market data.',
                  borderColor: '#00FF99',
                },
                {
                  title: 'Follow Proven Reports',
                  description:
                    'By using ThinkSabio, you can follow the Unique Reports and achieve the success of top institutional investors.',
                  borderColor: '#00FF99',
                },
                {
                  title: 'Proven Success',
                  description:
                    "We've helped many subscribers invest wisely, and we'd be happy to do the same for you.",
                  borderColor: '#00FF99',
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: '#112A3B',
                    border: `3px solid ${feature.borderColor}`,
                    padding: 20,
                    borderRadius: 10,
                    textAlign: 'center',
                    transition: 'all 0.3s ease-in-out',
                    cursor: 'pointer',
                    boxShadow: '0px 4px 10px rgba(0, 255, 153, 0.3)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow =
                      '0px 0px 15px rgba(0, 255, 153, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow =
                      '0px 4px 10px rgba(0, 255, 153, 0.3)';
                  }}
                >
                  <h3
                    style={{
                      fontSize: 20,
                      fontWeight: 'bold',
                      color: feature.borderColor,
                    }}
                  >
                    {feature.title}
                  </h3>
                  <p style={{ color: '#D3D3D3', fontSize: 16, marginTop: 10 }}>
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ) : subTab === 'Our Features' ? (
          <div
            style={{
              color: '#FFFFFF',
              textAlign: 'center',
              padding: 40,
            }}
          >
            <p
              style={{
                maxWidth: 800,
                margin: 'auto',
                color: '#D3D3D3',
                fontSize: 18,
              }}
            >
              ThinkSabio is an innovative investment platform designed to
              simplify investing with data-driven analytical reports and
              insights. Whether you're a beginner or an experienced investor,
              ThinkSabio offers powerful tools to help you make informed
              decisions.
            </p>

            {/* Feature Cards Section */}
            <div
              style={{
                display: 'flex',
                width: '90%',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 15,
                margin: 'auto',
                marginTop: 30,
              }}
            >
              {[
                {
                  title: 'Stock Price Trends',
                  description:
                    'ThinkSabio provides up-to-date stock data, ensuring investors can track market movements and make informed decisions.',
                },
                {
                  title: 'Custom Alerts & Notifications',
                  description:
                    'Users can set customized notifications for stock price changes, news updates, and significant market trends.',
                },
                {
                  title: 'Virtual Trading',
                  description:
                    'Monitor and optimize your investments with the Virtual Portfolio Performance Tracker. This feature allows users to simulate and track their investment strategies without real financial risk.',
                },
                {
                  title: 'User-Friendly Interface',
                  description:
                    "ThinkSabio's intuitive user interface ensures a seamless experience, whether you're a novice or a seasoned investor.",
                },
                {
                  title: 'Free Trial',
                  description:
                    'Try before you buy! ThinkSabio offers a 7-day free trial, providing full access to all web features and exclusive Telegram groups.',
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: '#112A3B',
                    border: '3px solid #00FF99',
                    padding: 20,
                    width: '90%', // Mobile friendly
                    maxWidth: 350, // Limit width for larger screens
                    textAlign: 'center',
                    borderRadius: 12,
                    transition: 'all 0.3s ease-in-out', // Smooth animations
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.border = '4px solid #00FF99';
                    e.currentTarget.style.boxShadow =
                      '0px 0px 15px rgba(0, 255, 153, 0.6)';
                    e.currentTarget.style.transform = 'scale(1.05)'; // Zoom effect
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.border = '3px solid #00FF99';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.transform = 'scale(1)'; // Reset zoom
                  }}
                >
                  <h3
                    style={{
                      color: '#00FF99',
                      fontSize: 22,
                      fontWeight: 'bold',
                    }}
                  >
                    {feature.title}
                  </h3>
                  <p style={{ color: '#D3D3D3', fontSize: 15, marginTop: 10 }}>
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ) : subTab === 'Success Stories' ? (
          <div
            style={{
              color: '#FFFFFF',
              textAlign: 'center',
              padding: 40,
              position: 'relative',
            }}
          >
            {/* Title */}
            <h2
              style={{
                fontSize: 32,
                fontWeight: 'bold',
                color: '#00FF99',
                marginBottom: 30,
                marginTop: 50,
              }}
            >
              Success Stories
            </h2>

            {/* Video Section */}
            <div style={{ textAlign: 'center', marginBottom: 50 }}>
              <video
                style={{
                  margin: 'auto',
                  maxWidth: '100%',
                  height: 'auto',
                }}
                width={isMobile ? '80%' : '40%'}
                height={isMobile ? '80%' : '40%'}
                src="https://thinksabio-asset.s3.amazonaws.com/ts_testimonial.mp4"
                controls={true}
                disablePictureInPicture
                controlsList="nodownload"
                playsInline
                autoPlay
                // muted
                id="myVideo"
                poster="https://thinksabio-asset.s3.amazonaws.com/Thinksabio_poster.png"
                ref={vidRef}
              >
                <source
                  src="https://thinksabio-asset.s3.amazonaws.com/ts_testimonial.mp4"
                  type="video/mp4"
                />
              </video>
            </div>

            {/* Timeline Section */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                width: '100%',
              }}
            >
              {/* Vertical Timeline Line (Laptop only) */}
              {!isMobile && (
                <div
                  style={{
                    position: 'absolute',
                    width: 4,
                    backgroundColor: '#00FF99',
                    top: 0,
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                  }}
                ></div>
              )}

              {/* Testimonial Boxes */}
              {[
                {
                  name: 'Vishnu Narayana Reddy Gaddam',
                  feedback:
                    'I keep watching recommendations from Sai Ram and whenever Sai Ram buys a lot on particular stocks .. it gives me more confidence.. that’s how I took risk and I put 80% of my investment. A Thanks is not good enough to thinksabiogroup.',
                },
                {
                  name: 'Surendra',
                  feedback:
                    "Using ThinkSabio helped me achieve a 30% profit from my investments, and the team's consistent support has been a huge help in my continued investing efforts.",
                },
                {
                  name: 'Srinivas',
                  feedback:
                    'After joining ThinkSabio, my portfolio value grew ten times greater.',
                },
                {
                  name: 'P N',
                  feedback:
                    'Sai, one of my RH portfolios was 10K in Jan 2024. Though it was in TS from 2021, I never paid attention. Last October, I started following this group! My portfolio has increased to 33K in just four months. Thank you, thank you TS team, and of course, Mr. Sai.',
                },
                {
                  name: 'Abhishek',
                  feedback:
                    'I want to thank the customer support team at ThinkSabio. Admins are available 24/7, and whenever we request any data, they provide it instantly.',
                },
                {
                  name: 'Venu Gopal Reddy',
                  feedback:
                    'After one year of working with ThinkSabio, my portfolio recorded its highest returns ever. I want to thank ThinkSabio and its amazing platform for helping people like me achieve financial liberty.',
                },
              ].map((story, index) => {
                const isLeft = index % 2 === 0 && !isMobile; // Ensuring left-right placement

                return (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      justifyContent: isMobile
                        ? 'center'
                        : isLeft
                        ? 'flex-end'
                        : 'flex-start',
                      alignItems: 'center',
                      width: '100%',
                      position: 'relative',
                      padding: '20px 0',
                      flexDirection: isMobile ? 'column' : 'row',
                    }}
                  >
                    {/* Branch Line (Laptop only) */}
                    {!isMobile && (
                      <div
                        style={{
                          position: 'absolute',
                          width: 300,
                          height: 2,
                          backgroundColor: '#00FF99',
                          top: '50%',
                          left: isLeft ? '50%' : 'auto',
                          right: isLeft ? 'auto' : '50%',
                          transform: 'translateX(0)',
                        }}
                      ></div>
                    )}

                    {/* Testimonial Box */}
                    <div
                      style={{
                        backgroundImage:
                          'url("https://thinksabio-asset.s3.us-east-1.amazonaws.com/noteWithPin.png")',
                        opacity: 0.85,
                        backgroundSize: 'cover',
                        backgroundPosition: 'top',
                        border: '3px solid #00FF99',
                        padding: 20,
                        borderRadius: 12,
                        textAlign: 'center',
                        width: isMobile ? '90%' : 420,
                        height: isMobile ? 'auto' : '280px',
                        paddingTop: isMobile ? '20px' : '35px',
                        boxShadow: '0px 4px 10px rgba(0, 255, 153, 0.3)',
                        color: '#FFFFFF',
                        display: 'flex',
                        flexDirection: 'column',
                        marginLeft: isLeft && !isMobile ? 'auto' : 50,
                        marginRight: isLeft && !isMobile ? 50 : 'auto',
                        transition: 'all 0.3s ease-in-out', // Smooth transition effect
                        cursor: 'pointer', // Indicating interactivity
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                        e.currentTarget.style.boxShadow =
                          '0px 0px 15px rgba(0, 255, 153, 0.6)'; // Glowing effect
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow =
                          '0px 4px 10px rgba(0, 255, 153, 0.3)';
                      }}
                    >
                      <h3
                        style={{
                          fontSize:
                            story.name === 'Vishnu Narayana Reddy Gaddam'
                              ? 18
                              : 23,
                          fontWeight: 'bold',
                          color: 'black',
                          fontFamily: "'Dancing Script', cursive",
                          transform: 'rotate(-5deg)',
                          display: 'inline-block',
                        }}
                      >
                        {story.name}
                      </h3>
                      <p
                        style={{
                          fontSize: 16,
                          marginTop: 40,
                        }}
                      >
                        {story.feedback}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default WhoWeAre;
